import { Bar, bars } from "../data/bars"
import { Badge, diggerBadges } from "../data/badges"
import { miles } from "../data/miles"
import { DiggerCard } from "./../data/diggers"

export function getDiggerMiles(digger: DiggerCard) {
  return miles.filter(
    (mile) => mile.diggers && mile.diggers.includes(digger.id)
  )
}

export function getDiggerBars(digger: DiggerCard) {
  const diggerBarsMile1 = digger.bars.mile1
    ? (digger.bars.mile1
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile2 = digger.bars.mile2
    ? (digger.bars.mile2
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile25 = digger.bars.mile25
    ? (digger.bars.mile25
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile3 = digger.bars.mile3
    ? (digger.bars.mile3
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile4 = digger.bars.mile4
    ? (digger.bars.mile4
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile5 = digger.bars.mile5
    ? (digger.bars.mile5
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile6 = digger.bars.mile6
    ? (digger.bars.mile6
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsMile7 = digger.bars.mile7
    ? (digger.bars.mile7
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []
  const diggerBarsExtra = digger.bars.extra
    ? (digger.bars.extra
        .map((barId) => bars.find((bar) => bar.id === barId))
        .filter(Boolean) as Bar[])
    : []

  return {
    mile1: {
      image: "bar1",
      bars: diggerBarsMile1,
    },
    mile2: {
      image: "bar2",
      bars: diggerBarsMile2,
    },
    mile25: {
      image: "bar25",
      bars: diggerBarsMile25,
    },
    mile3: {
      image: "bar3",
      bars: diggerBarsMile3,
    },
    mile4: {
      image: "bar4",
      bars: diggerBarsMile4,
    },
    mile5: {
      image: "bar5",
      bars: diggerBarsMile5,
    },
    mile6: {
      image: "bar6",
      bars: diggerBarsMile6,
    },
    mile7: {
      image: "bar7",
      bars: diggerBarsMile7,
    },
    extra: {
      image: "extra",
      bars: diggerBarsExtra,
    },
  }
}

export function getDiggerLevel(digger: DiggerCard) {
  const diggerBars = getDiggerBars(digger)
  const level = Object.values(diggerBars).reduce(
    (acc, mile) => acc + mile.bars.length,
    0
  )
  return level
}

export function getDiggerLevelUnique(digger: DiggerCard) {
  const diggerBars = getDiggerBars(digger)
  let bars: Bar[] = []
  Object.values(diggerBars).forEach((mile) => {
    mile.bars.forEach((bar) => {
      if (bars.findIndex((_bar) => bar.id === _bar.id) < 0) {
        bars.push(bar)
      }
    })
  })
  return bars.length
}

export const getDiggerBadges = (digger: DiggerCard) => {
  if (!digger) return [] as Badge[]
  const badges = digger.badges?.map((badgeId) => {
    const badge = diggerBadges.find((badge: Badge) => badge.id === badgeId)
    return badge ? badge : null
  })
  return badges.filter((_) => _) as Badge[]
}
